import React, { createContext, useContext, useEffect, useState } from "react";

type DeviceContextType = {
    isTouchDevice: boolean;
};

export const DeviceContext = createContext<DeviceContextType | undefined>(undefined);

export const DeviceProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [isTouchDevice, setIsTouchDevice] = useState(false);


    useEffect(() => {
        const handleTouchStart = () => setIsTouchDevice(true);

        window.addEventListener("touchstart", handleTouchStart, { once: true });

        return () => {
            window.removeEventListener("touchstart", handleTouchStart);
        };
    }, []);

    return (
        <DeviceContext.Provider value={{ isTouchDevice }}>
            {children}
        </DeviceContext.Provider>
    );
};